import FormField from '@cloudscape-design/components/form-field'
import Select from '@cloudscape-design/components/select'
import Input from '@cloudscape-design/components/input'
import SpaceBetween from '@cloudscape-design/components/space-between'
import Toggle from '@cloudscape-design/components/toggle'

interface Props {
  autoGenerateEnabled: boolean
  cadence: string
  timeLocal: string
  onAutoGenerateChange: (v: boolean) => void
  onCadenceChange: (v: string) => void
  onTimeLocalChange: (v: string) => void
}

const CADENCES = [
  { label: 'Daily', value: 'daily' },
  { label: 'Weekly (Monday & Thursday)', value: 'weekly' },
]

export function StepSchedule({
  autoGenerateEnabled, cadence, timeLocal,
  onAutoGenerateChange, onCadenceChange, onTimeLocalChange,
}: Props) {
  return (
    <SpaceBetween size="m">
      <FormField label="Enable autonomous content generation?" stretch>
        <Toggle checked={autoGenerateEnabled} onChange={e => onAutoGenerateChange(e.detail.checked)}>
          {autoGenerateEnabled ? 'Enabled' : 'Disabled'}
        </Toggle>
      </FormField>
      {autoGenerateEnabled && (
        <>
          <FormField label="How often?" stretch>
            <Select
              selectedOption={CADENCES.find(c => c.value === cadence) ?? null}
              onChange={e => onCadenceChange(e.detail.selectedOption.value ?? 'daily')}
              options={CADENCES}
            />
          </FormField>
          <FormField label="Time (your local time, HH:MM)" stretch>
            <Input value={timeLocal} onChange={e => onTimeLocalChange(e.detail.value)} placeholder="09:00" />
          </FormField>
        </>
      )}
    </SpaceBetween>
  )
}
